import { render } from "./DebugPanel.vue?vue&type=template&id=143387e3&scoped=true"
import script from "./DebugPanel.vue?vue&type=script&lang=js"
export * from "./DebugPanel.vue?vue&type=script&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=143387e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143387e3"]])

export default __exports__